import { render } from "./ModalConfirm.vue?vue&type=template&id=5f06d5a3"
import script from "./ModalConfirm.vue?vue&type=script&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&lang=js"
script.render = render

export default script